var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Draggable } from "@hello-pangea/dnd";
import { CheckBadgeIcon } from "@heroicons/react/24/outline";
import { useContext, useState } from "@wordpress/element";
import { TaskControlsDropdown } from "../../../../components/Dropdown/TaskControlsDropdown/TaskControlsDropdown";
import { UserAssignementDropdown } from "../../../../components/Dropdown/UserAssignementDropdown/UserAssignementDropdown";
import { Loading } from "../../../../components/Loading/Loading";
import { OPEN_EDIT_TASK_MODAL, PIPELINE_CHANGE_TASK_DONE_STATUS, } from "../../../../constants";
import { useTaskActions } from "../../../../hooks/actions/useTaskActions";
import { ActivePipelineContext } from "../../../../providers/ActivePipelineContextProvider";
import { ModalContext } from "../../../../providers/ModalContextProvider";
function Task({ task, index }) {
    const { modalDispatch } = useContext(ModalContext);
    const openEditTaskModal = () => {
        modalDispatch({
            type: OPEN_EDIT_TASK_MODAL,
            payload: {
                taskToEdit: task,
            },
        });
    };
    return (_jsx(Draggable, { draggableId: task.id, index: index, children: (provided) => (_jsxs("div", Object.assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { className: "wpqt-relative wpqt-mx-3 wpqt-mb-2 wpqt-flex !wpqt-cursor-pointer wpqt-flex-col wpqt-gap-1 wpqt-rounded wpqt-border wpqt-border-gray-200 wpqt-bg-white wpqt-p-3 wpqt-shadow", onClick: openEditTaskModal, children: [_jsx("div", { className: "wpqt-absolute wpqt-right-[12px] wpqt-top-[12px]", children: _jsx(TaskControlsDropdown, { task: task }) }), _jsx("div", { className: "wpqt-text-base", children: task.name }), task.description && (_jsx("div", { className: "wpqt-text-sm wpqt-italic", children: task.description })), _jsx("div", { className: "wpqt-mt-2", children: _jsx(UserAssignementDropdown, { task: task }) }), _jsx(TaskActions, { task: task })] }))) }, task.id));
}
function TaskActions({ task }) {
    const { dispatch } = useContext(ActivePipelineContext);
    const { changeTaskDoneStatus } = useTaskActions();
    const [loading, setLoading] = useState(false);
    const isTaskCompleted = task.is_done;
    const changeDone = (done) => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        yield changeTaskDoneStatus(task.id, done, (isCompleted) => {
            dispatch({
                type: PIPELINE_CHANGE_TASK_DONE_STATUS,
                payload: { taskId: task.id, done: isCompleted },
            });
        });
        setLoading(false);
    });
    if (loading) {
        return _jsx(Loading, { ovalSize: "24" });
    }
    return (_jsx("div", { className: "wpqt-flex wpqt-justify-center", children: isTaskCompleted ? (_jsx(CheckBadgeIcon, { className: "wpqt-size-6 wpqt-icon-green", onClick: (e) => {
                e.stopPropagation();
                changeDone(false);
            } })) : (_jsx(CheckBadgeIcon, { className: "wpqt-size-6 wpqt-icon-gray", onClick: (e) => {
                e.stopPropagation();
                changeDone(true);
            } })) }));
}
export { Task };
